const { routes } = require('./routes');

const StaticNavContents = [
  {
    path: routes.TierListMaker(),
    title: 'Tier List Maker',
    pages: []
  },
  {
    path: routes.PostHub(),
    title: 'News',
    pages: []
  }
];

const GameNavContents = games => {
  const contents = games.map(({ iconSmall, name }) => {
    return {
      path: routes.GameHub(name),
      iconURI: iconSmall ? iconSmall.url : null,
      title: `${name} Wiki`,
      pages: [
        {
          path: routes.TierListHub(name),
          iconURI: iconSmall ? iconSmall.url : null,
          title: `${name} Tier Lists`
        }
      ]
    };
  });
  return contents;
};

export { GameNavContents, StaticNavContents };
